__turbopack_context__.v({
  "table": "L_xBXa_table",
});
